(function () {
  'use strict';

  function underwritingNotesDataService($http) {
      var baseUrl = '[BuildifyApiHost]/api/underwritingnotes';

      function getNewNotes() {
          return $http.get(baseUrl + '/new').then(
              function (response) {
                  return response.data;
              });
      }

      function getResolvedNotes() {
        return $http.get(baseUrl + '/resolved').then(
            function (response) {
                return response.data;
            });
    }

      return {
        getNewNotes: getNewNotes,
        getResolvedNotes: getResolvedNotes
      }
  }

  underwritingNotesDataService.$inject = ['$http'];

  angular.module('ecap.dashboards').service('underwritingNotesDataService', underwritingNotesDataService);
})();
